import { render, staticRenderFns } from "./ConsentsRequired.vue?vue&type=template&id=4c2b232d"
import script from "./ConsentsRequired.vue?vue&type=script&lang=js"
export * from "./ConsentsRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports